let customSelectors = {
    "sidebarBtn": window.themeVariables.settings.showSidebar ? document.getElementById('toggle-vertical-sidebar'): {},
    "sidebar": document.querySelector('.vertical-menu'),
    "sidebarAccordionTitle": window.themeVariables.settings.showSidebar ? document.querySelector('.vertical-menu').querySelectorAll('.sidebar-accordion-title') : {},
    "sidebarAccordionContent": window.themeVariables.settings.showSidebar ? document.querySelector('.vertical-menu').querySelectorAll('.sidebar-accordion-content'): {}
},
customFunctions = {
    'addEventToSidebarBtn' : () => customSelectors.sidebarBtn.addEventListener('click', e => {
        e.preventDefault();
        document.querySelector('.main-content-inner ').classList.toggle('active');
    }),
    'addAccordionToSidebar': () => {
        customSelectors.sidebar.addEventListener('click', (e)=>{
            let ele = e.target.parentElement;
            if(ele.classList.contains('sidebar-accordion-title')){
                e.preventDefault();
                let index = ele.dataset.index;
                customFunctions.closeAllSidebarMenus(index);
                customSelectors.sidebar.querySelector(`p[data-index="${index}"]`).classList.toggle('active');
                customSelectors.sidebar.querySelector(`ul[data-index="${index}"]`).classList.toggle('hide');
            }
        })
    },
    'closeAllSidebarMenus': position => {
        customSelectors.sidebarAccordionContent.forEach((ele, index) => {
            let accordionTitle = customSelectors.sidebar.querySelectorAll('[data-index]')[index];
            if(ele.dataset.index != position) ele.classList.add('hide');
            if(accordionTitle.dataset.index != position) accordionTitle.classList.remove('active');
        })
    },
    'init': () => {
        window.themeVariables.settings.showSidebar && (customFunctions.addEventToSidebarBtn(), customFunctions.addAccordionToSidebar());
    },
};

(() => customFunctions.init())();

/* Tripster Developers: null-guarded the tech-table clone block. It previously ran on every page and threw "cloneNode/appendChild of null" on any page without .technial_table (homepage, collections). Behavior on product pages that have the table is unchanged. */
var sourceElement = document.querySelector(".technial_table");
var target1 = document.querySelector(".techtablkem");
var target = document.querySelector(".techtablke");
if (sourceElement && target1 && target) {
  target1.appendChild(sourceElement.cloneNode(true));
  target.appendChild(sourceElement.cloneNode(true));
  if (document.querySelectorAll(".technial_table td").length === 0) {
    target1.style.display = "none";
    target.style.display = "none";
  }
}
$('body').on('mouseover','.swatch-view-item',function(){
    let id = $(this).attr('orig-value');
    let imgStyle = $(this).find('.star-set-image').attr('style');
    let imgSrc = imgStyle.split("//");
    imgSrc = imgSrc[1].replace(");").split("?")[0];
    // console.log(imgStyle, 'imgSrc');
    if(imgSrc){
      $('.product-gallery__media-list .product-gallery__media.is-selected img').attr('srcset', '//'+imgSrc);
    }
    let parentEle = $(this).parents('fieldset');
    $(parentEle).find('.swatch-variant-name').text(` - ${id}`);
}).on('mouseout','.swatch-view-item',function(){
    let parentEle = $(this).parents('fieldset');
    let selectedVariant = $('.swatch-view-item[aria-checked="true"]').attr('orig-value');
    $(parentEle).find('.swatch-variant-name').text(` - ${selectedVariant}`);

    let imgStyle = $('.swatch-view-item[aria-checked="true"]').find('.star-set-image').attr('style');
    let imgSrc = imgStyle.split("//");
    imgSrc = imgSrc[1].replace(");").split("?")[0];
    // console.log(imgStyle, 'imgSrc', 'else');
    if(imgSrc){
      $('.product-gallery__media-list .product-gallery__media.is-selected img').attr('srcset', '//'+imgSrc);
    }
});
/* ==========================================================================
   Tripster Developers 2026-08-27: the `;` above is load-bearing.

   Without it this file parsed as `$('body').on(...)(function(){...})()` - the
   jQuery object returned by .on() called as a function - which threw a
   TypeError at parse-time-adjacent execution and silently killed EVERY
   statement below it. That means the mega-menu slider arrows have never run
   since they were added on 2026-08-26. Found while debugging why the collection
   count sync at the bottom of this file never fired.
   ========================================================================== */

/* ==========================================================================
   Tripster Developers - mega menu featured slider (2026-08-26)
   Delegated handlers for the one best-seller slider in each mega menu panel.
   Lives here, not in snippets/mega-menu-horizontal.liquid: an inline <script>
   sibling of .mega-menu inside <details> stopped the theme's
   mega-menu-disclosure element from opening the panel on hover.
   ========================================================================== */
(function () {
  if (window.__tdpMegaSlider) return;
  window.__tdpMegaSlider = true;

  var GAP = 16;

  function syncArrows(track) {
    var featured = track.closest('.tdp-mega__featured');
    if (!featured) return;
    var prev = featured.querySelector('[data-tdp-mega-scroll="-1"]');
    var next = featured.querySelector('[data-tdp-mega-scroll="1"]');
    var max = track.scrollWidth - track.clientWidth;
    // While the panel is closed clientWidth is 0, so treat that as "not scrolled yet".
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = max <= 1 || track.scrollLeft >= max - 1;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tdp-mega-scroll]');
    if (!btn) return;
    e.preventDefault();
    var featured = btn.closest('.tdp-mega__featured');
    var track = featured && featured.querySelector('.tdp-mega__track');
    if (!track) return;
    var card = track.querySelector('.tdp-mega__card');
    var step = (card ? card.getBoundingClientRect().width : 148) + GAP;
    var dir = parseInt(btn.getAttribute('data-tdp-mega-scroll'), 10) || 1;
    track.scrollBy({ left: step * 2 * dir, behavior: 'smooth' });
  });

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('tdp-mega__track')) syncArrows(t);
  }, true);

  /* Tripster Developers 2026-08-30: random draw from the best-seller pool. The track
     renders 2x the visible count (sorted best-selling); Fisher-Yates once per page
     load so repeat visitors see different top sellers. */
  document.querySelectorAll('.tdp-mega__track[data-tdp-shuffle]').forEach(function (track) {
    var cards = Array.prototype.slice.call(track.children);
    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      track.appendChild(cards[j]); cards.splice(j, 1);
      // appendChild-based shuffle: move a random remaining card to the end each pass
    }
  });

  // A closed panel has zero width, so arrow state can only be resolved once it opens.
  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.tagName === 'DETAILS' && e.target.hasAttribute('open')) {
      var tracks = e.target.querySelectorAll('.tdp-mega__track');
      for (var i = 0; i < tracks.length; i++) syncArrows(tracks[i]);
    }
  }, true);
})();

/* ----------------------------------------------------------------------
   Tripster Developers 2026-08-27 (later): the count sync is REMOVED.

   It used to overwrite the theme's Liquid `products_count` with the filter app's
   number, because the app hides out-of-stock products and therefore rendered fewer
   cards than the top bar claimed (356 vs 344 on rubber-straps).

   That created a worse problem once the fitment finder shipped: the finder reads
   Liquid's collection count, so its tile said 3,119 for 20mm while the page it
   routed to said 3,085. Two prominent numbers disagreeing across a single click is
   far more visible than a top-bar count being 1% above the cards on screen.

   Everything now reads ONE source - Liquid's `collection.products_count` - so the
   finder tile, the CTA label and the destination top bar always agree, live, with
   nothing to regenerate.

   This also lines up with the decision already taken to stop hiding sold-out
   products: the moment that toggle is flipped in the filter app, the app's number
   and Liquid's number become the same figure and the card count reconciles too.
   ---------------------------------------------------------------------- */

/* ==========================================================================
   Tripster Developers 2026-09-18 (rev 3) - ONE GUIDE PREDICATE, SHARED.
   Retainer tasks #9 and #25.

   WHY THIS BLOCK EXISTS.
   Rev 2 filtered measurement guides out of the HOVER slot and left the ARROW
   list untouched, because each path carried its own idea of what a guide is:
   one had the test, the other had none. QA measured the consequence on the
   client's own page - card 13 of /collections/watch-bands-for-omega hovered to
   the correct photograph and then showed "CHECK MODEL & LINK WIDTH BEFORE
   ORDERING" after a single click on our own next arrow. 14 of 241 cards on
   /collections/all did the same, and 1,474 of 2,000 products (73.7%) carry a
   guide somewhere in product.images, so the arrow list is far more exposed
   than the 1.05% that sit in the hover slot itself.

   The test now lives in exactly ONE place and every consumer calls it. A path
   that forgets to filter is a MISSING CALL - visible in a grep - rather than a
   second copy of the rule that silently rots out of step with this one.

   It hangs off `window` rather than a shared closure because the consumers are
   deliberately separate IIFEs: the card-interaction block and the hover
   backstop have different failure modes and neither should take the other down.
   ========================================================================== */
(function () {
  if (window.__tdpGuide) return;

  var GUIDE_NAME = /(^|[\/_-])(mg_?\d|guid|measure)/i;

  /* 8-hex FNV-1a of each guide file name, concatenated. Checked against every
     one of the 110,267 media file names in the catalogue: zero collisions.
     Most guides are uploaded as `ewp<sku>-<hex>-2.png`, named exactly like a
     product photograph, so the name test alone cannot see them. Regenerate
     with 31-hover-guide/iterate.py if the catalogue changes. */
  /* Tripster Developers 2026-09-26: list refreshed from the live catalogue (+128 guide-type file names re-sent from SureDone since 18 Sep, 1 name excluded because it collides with a real photo). */
  var PACKED = '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';
  var GUIDE_HASH = Object.create(null);
  for (var _i = 0; _i < PACKED.length; _i += 8) GUIDE_HASH[PACKED.substr(_i, 8)] = 1;

  function fnv(s) {
    var h = 2166136261;
    for (var i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
    }
    return ('0000000' + h.toString(16)).slice(-8);
  }

  // Bare file name of a URL, query and path stripped. '' for a data: URI.
  function nameOf(url) {
    var s = String(url || '');
    if (!s || s.indexOf('data:') === 0) return '';
    return s.split('/').pop().split('?')[0];
  }

  /* A lazy-loaded card image carries a 1x1 data: GIF in src and the real file
     in srcset. Reading only src would call every un-scrolled card "not a guide"
     and the fix would work above the fold and nowhere else. */
  function fileOf(img) {
    if (!img) return '';
    var s = img.currentSrc || img.getAttribute('src') || '';
    if (!s || s.indexOf('data:') === 0) {
      s = img.getAttribute('data-src') || img.getAttribute('data-original') || '';
    }
    if (!s || s.indexOf('data:') === 0) {
      var ss = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
      s = (ss.split(',')[0] || '').trim().split(' ')[0];
    }
    return nameOf(s);
  }

  /* Tripster Developers 28 Sep (Task 9): real part photos wrongly caught by the guide scan
     (a red "where it fits" arrow, not a size guide). Never treat these as guides. */
  var NOT_GUIDE = /^ewp9330791791-bdb6bd99d8932019b88ce80aba0535372ef98da9-3/i;
  function isGuideName(n) {
    if (!n || NOT_GUIDE.test(n)) return false;
    return GUIDE_NAME.test(n) || GUIDE_HASH[fnv(n)] === 1;
  }

  /* THE SINGLE TEST. Everything else on this page is a wrapper around it. */
  function isGuideUrl(url) { return isGuideName(nameOf(url)); }
  function isGuideImg(img) { return isGuideName(fileOf(img)); }

  /* ------------------------------------------------------------------
     SUPPRESSING THE CROSS-FADE - task #25's second half.

     The client's acceptance (sheet G25) is "Hover on a collection card shows a
     REAL SECOND PHOTO of the part". A card whose two faces hold the same file
     satisfies "not blank" and "not a guide" and still fails that sentence: it
     cross-fades a photograph into itself, which a shopper reads as the hover
     being broken. Measured after the 06:08 publish: 7 of 28 on the client's
     Omega page, 28 of 241 on /collections/all.

     Where there is genuinely only one usable photograph the honest answer is
     for the hover NOT TO FIRE. We do that by pinning the two layers inline
     instead of stripping the app's classes, because Globo re-renders the grid
     client-side on every filter, sort and page change and would put any class
     we removed straight back.

     Inline `!important` is what it takes: Globo's own rule is
       .spf-product-card__image-wrapper.hover-effect:hover
           .spf-product-card__image-main { opacity: 0 !important }
     and an inline important declaration is the only thing that outranks an
     author important one.

     NOTE this never hides anything. `display:none` on the hover layer is what
     produced the white tile in rev 1 of task #25; the main photograph is pinned
     VISIBLE and the hover layer pinned transparent underneath it, so the worst
     case is a card that simply does not react to the pointer.
     ------------------------------------------------------------------ */
  function suppressHover(wrap, main, secondary) {
    if (!wrap || !main) return false;
    /* GUARD ON THE STATE, NEVER ON THE FLAG. The filter app swaps fresh <img>
       nodes into a wrapper that keeps our attribute, and those nodes carry no
       inline style - so an attribute-only check would report "already pinned"
       for a card that is once again cross-fading to a duplicate. */
    if (wrap.getAttribute('data-tdp-hover-off') === '1' &&
        main.style.getPropertyValue('opacity') === '1' &&
        (!secondary || secondary.style.getPropertyValue('opacity') === '0')) return false;
    wrap.setAttribute('data-tdp-hover-off', '1');
    main.style.setProperty('opacity', '1', 'important');
    if (secondary) secondary.style.setProperty('opacity', '0', 'important');
    return true;
  }

  function releaseHover(wrap, main, secondary) {
    var pinned = (wrap && wrap.getAttribute('data-tdp-hover-off') === '1') ||
                 (main && main.style.getPropertyValue('opacity') === '1') ||
                 (secondary && secondary.style.getPropertyValue('opacity') === '0');
    if (!pinned) return false;
    if (wrap) wrap.removeAttribute('data-tdp-hover-off');
    // clear the inline pin wherever it actually is, not only where we filed it
    if (main) main.style.removeProperty('opacity');
    if (secondary) secondary.style.removeProperty('opacity');
    return true;
  }

  /* ------------------------------------------------------------------
     photosOf(product) - the product's real photographs, in gallery order.

     Two filters, one place:
       1. the name / content-hash test above
       2. SHAPE - but only where the shape actually buys something.

     Tripster Developers 2026-09-18 (rev 4) - FOUR SHAPES REMOVED.

     Rev 3 shipped seven shapes chosen from a 150-product sample. Measured
     afterwards over the WHOLE catalogue - 17,243 products, 109,930 images -
     four of them were almost pure false positives, and the rule was hiding
     real product photographs from shoppers, 21 of them a product's position-1
     main image:

       shape       in catalogue   caught by name   marginal guides   photos lost
       2001x1500         13,641           13,638            3              0
       1200x1095             77               38           39              1
       1600x1459             23               12           11              1
       1200x925              11                0           11             11   REMOVED
       1600x1375             58                0           58             58   REMOVED
       1600x1519             33                0           33             33   REMOVED
       1600x1552             36                0           36             30   REMOVED

     The four removed shapes bought 9 extra guide images between them and cost
     134 real photographs; three of them caught no guide the name test had not
     already caught. Removing them takes 132 of those 134 false positives away
     and gives up 6 chart images. The three kept shapes are the ones whose
     marginal value is positive.

     THE HEADLINE NUMBER THAT JUSTIFIED REV 3 WAS REDUNDANT. "2001x1500 is 175
     of 193 guides" was true and meaningless: the name test already catches
     13,638 of those 13,641 images on its own.

     TWO RULES THIS BLOCK EXISTS TO ENFORCE.
       * A shape is never adopted or kept on the evidence of one collection or
         one sample. It is scored over the catalogue census - 39-shape-rule-
         rollback/census.py - counting BOTH the guides it adds beyond the name
         test AND the photographs it costs. A shape whose marginal guide count
         is zero is a false-positive generator, nothing else.
       * An earlier variant compared each media to the product's own modal
         shape. It scored 41/41 on the client's collection and dropped 29.1% of
         real photographs catalogue-wide. Rev 3 then made the same mistake in a
         different costume. Do not make it a third time.

     The failure mode here is under-catching, never over-dropping: a guide that
     slips through is one bad frame in a carousel, a photograph wrongly
     suppressed is merchandise the shopper can never see. Being per-image, this
     is indifferent to media ORDER, so a re-run of 20-media-order/
     fronts_first.py cannot disarm it.
     ------------------------------------------------------------------ */
  var GUIDE_SHAPE = {
    '1200x1095': 1, '1600x1459': 1, '2001x1500': 1
  };

  function isGuideShape(w, h) {
    return !!(w && h && GUIDE_SHAPE[w + 'x' + h] === 1);
  }

  /* THE WHOLE TEST, for any consumer that has a URL and (optionally) the
     pixel dimensions Shopify ships alongside it - product.media[] entries and
     variant.featured_image both carry width/height. Every consumer calls THIS,
     so a path that forgets one half of the rule is a missing call visible in a
     grep rather than a second, quietly diverging copy of it. */
  function isGuide(src, w, h) {
    return isGuideUrl(src) || isGuideShape(w, h);
  }

  function photosOf(p) {
    var media = [], out = [], i, m;
    if (p && p.media) {
      for (i = 0; i < p.media.length; i++) {
        m = p.media[i];
        if (m && m.media_type === 'image' && m.src) media.push(m);
      }
    }
    if (!media.length) {
      // older or odd payloads: the URL list and the name test alone
      return (p && p.images ? p.images : []).filter(Boolean)
        .filter(function (u) { return !isGuideUrl(u); });
    }
    for (i = 0; i < media.length; i++) {
      m = media[i];
      if (isGuide(m.src, m.width, m.height)) continue;
      out.push(m.src);
    }
    return out;
  }

  window.__tdpGuide = {
    fileOf: fileOf,
    photosOf: photosOf,
    nameOf: nameOf,
    isGuideName: isGuideName,
    isGuideShape: isGuideShape,
    isGuide: isGuide,
    isGuideUrl: isGuideUrl,
    isGuideImg: isGuideImg,
    suppressHover: suppressHover,
    releaseHover: releaseHover
  };
})();

/* ==========================================================================
   Tripster Developers 2026-09-19 (rev 7) - THE CONTENT TEST.

   WHY THIS EXISTS. Rev 6 proved "the hover file differs from the rest file" on
   all 28 cards and QA re-ran that measurement, file for file, and agreed with
   it. Then QA looked at the PIXELS and failed it, because G25 is a sentence
   about a photograph - "a REAL SECOND PHOTO of the part, not the measurement
   guide" - and a file name cannot see any of those words:

     * 24-25mm-rubber-...-hublot-big-bang: rest ewp9200150-73eb....jpg 591x480,
       hover ewp9200150-73eb..._887971c4....jpg 1478x1200. Different file, SAME
       PHOTOGRAPH, re-uploaded larger. The shopper hovers and nothing happens.
       Our own standing rule broken in our own acceptance test: dedupe on
       content, never on a label.
     * bezel-insert-for-tudor-...-79090: the promoted photo is a whole ROLEX
       overprinted "WATCH NOT INCLUDED / ILLUSTRATION PURPOSE ONLY".
     * 15mm-...-cartier-roadster-...-blue and two more: the promoted photo is a
       DIFFERENT COLOURWAY of the part - a card titled BLUE fading to black.

   THREE RULES, ALL MEASURED ON THE WHOLE CATALOGUE BEFORE SHIPPING. The
   catalogue is 17,243 published products and 109,930 images; every one of them
   was fetched at ?width=128 and scored by exactly this arithmetic. The numbers
   are in 45-hover-content-test/EVIDENCE.md. This is the same discipline rev 4
   had to learn the hard way: a rule tuned on one collection dropped 29.1% of
   real photographs, and a rule tuned on a 150-product sample cost 134 more.

   1. SAME-CONTENT REJECTION.  rgbRms(a, b) < RMS_SAME  ->  not a second photo.
      Measured over all 159,462 within-product image pairs: 769 pairs sit below
      RGB-RMS 1, then a near-empty valley (169 pairs in the whole 1-6 band),
      then a rising continuum that is real, different photography. The hublot
      duplicate sits at 1.872. RMS_SAME is put at the floor of that valley.

      IT IS RGB, NOT LUMA, AND THAT IS LOAD-BEARING. A luma plane cannot see
      the difference between a black rubber strap and a BLUE one, or a steel
      buckle and a rose-gold one. Measured: of 16 sampled pairs in the luma
      1-6 band, FOUR were different colourways of the same shot, and a
      luma-based rule would have thrown them away as duplicates - which is the
      exact defect QA is making us fix on the Cartier card.

   2. SAME-STEM PREFERENCE.  `ewp9330791681-586f88....jpg`, `-2.jpg` and
      `-3.jpg` are the blue croc strap from three angles; `ewp9330791681-5e852a
      40...-5.jpg` is a different colourway. Preferring the main face's own
      stem is what stops a card titled BLUE fading to black, and it needs no
      threshold at all.

   3. COLOUR CONSISTENCY.  QA's ruling on the colourway cards is that a card
      showing BLUE at rest and BLACK on hover "actively misinforms", and that
      this is WORSE than showing one photo twice. Rule 2 fixes two of the three
      by itself. The third - the Oris strap - cannot be fixed by a stem, because
      its gallery holds exactly ONE orange photograph, uploaded FIVE times under
      five different SKU names (rgbRms 0.000 between all five, measured) and
      thirty-two photographs of other colours. There is no second orange photo
      to promote, so the honest answer is for the hover NOT TO FIRE.

      So a candidate whose mean colour, over its non-background pixels, is more
      than COLOUR_MAX away from the resting photograph's is refused, and a card
      with nothing left keeps rev 5's pin. Cost, measured over all 16,877
      products that have two or more non-guide photographs: the 99th percentile
      of that distance between a main face and the photo the picker chooses is
      113, and at COLOUR_MAX = 120 seventy-one products lose a hover they would
      otherwise have had - 0.42%. That 71 is an UPPER BOUND on what ships: this
      rule only runs on cards that go through promotion at all (the ones with no
      secondary element, or a secondary duplicating the main), not on the ~93%
      of cards where the app already renders a different second photograph.

   4. RED-INK OVERLAY REJECTION - and the honest limit of it.
      THE SHAPE WHITELIST IS THE WRONG LEVER and was already rolled back once
      for exactly this (rev 4: 1600x1552, 1600x1375 and 1600x1519 were hiding
      121 real photographs between them). So this is content, and it is narrow
      ON PURPOSE: it detects RED TEXT LAID OVER A PHOTOGRAPH - "WATCH NOT
      INCLUDED", "EXAMPLE", "Link not included" - by four properties together,
      each of which a red PRODUCT fails:
         Sn      enough near-pure red at all
         thin    one 4-neighbour erosion destroys >= 95% of it (a stroke, not
                 a shape - the red rubber Hublot strap in this catalogue is
                 6.95% red and only 36% of it erodes away)
         cols/rows  the red is laid out in wide, short bands (text lines)
         big/Sn  no single red blob holds more than a quarter of the red
                 (letters, not an object)
      Catalogue-wide: 1,105 of 109,930 images flagged (1.005%). 96 of them were
      pulled at random and looked at one by one: 95 carried red overlay text,
      ONE was a real photograph of a red leather strap. So the measured
      false-positive rate is 1 in 96 - about 11 real photographs catalogue-wide,
      against the 134 the shape rule cost.

      WHAT THIS DELIBERATELY DOES NOT CATCH, and why. The airwolf image (red
      dimension arrows reading "20mm", "7.2mm width", "3.8mm Thickness") has
      only 25 near-pure red pixels at 128px - it is thin line art, not a text
      block. Every threshold low enough to catch it also catches a red watch
      HAND, red stitching and a red-numeral date disc: measured, a rule at
      that sensitivity ran at 55% false positives on a 36-image sample, and
      raising the probe to 320px did not separate them either. So it is not
      caught here. The airwolf CARD is still fixed - by rule 2, which promotes
      the main face's own stem instead - and the residual is written up rather
      than papered over with a threshold that would destroy real merchandise.

   THE PROBE URL IS `?width=128`, NEVER THE DISPLAY URL. Two reasons, both
   load-bearing: it is ~4KB rather than ~60KB, and it is a DIFFERENT cache key
   from the `?width=540` the card renders, so the browser cannot hand back a
   copy it already fetched without CORS headers and taint the canvas.
   cdn.shopify.com serves `access-control-allow-origin: *`, verified on this
   store, which is what makes getImageData legal at all.

   AND THE PROBE ASKS FOR JPEG EXPLICITLY. This one cost a whole measurement.
   Shopify's CDN answers `Vary: Accept`: the census fetched these URLs with curl
   and got JPEG, while an `<img>` in Chrome gets AVIF - and AVIF's chroma
   compression at 128px destroys nine tenths of the near-pure red. The SAME
   image, the SAME url: 441 red pixels as JPEG, 42 as AVIF, both measured. A
   rule calibrated on the first and running on the second is not the rule that
   was measured. So the probe goes through `fetch(url, {Accept: 'image/jpeg'})`
   + `createImageBitmap`, which pins the codec on every browser and makes the
   shipped numbers identical to the census. `Accept` with that value is a
   CORS-safelisted header, so this costs no preflight. If fetch or
   createImageBitmap is missing the code falls back to a plain `<img>`, which is
   codec-negotiated: the duplicate and colour tests are unaffected (measured:
   rgbRms 1.685 AVIF vs 1.872 JPEG on the hublot pair) but the ink test will
   under-detect, which is the safe direction - it does nothing rather than
   something wrong.

   EVERY FAILURE PATH FAILS OPEN TO REV 6. Timeout, network error, tainted
   canvas, no canvas: `ok:false`, the content test is simply not applied, and
   the card behaves exactly as it did before this block existed. A content test
   that kills the hover when the CDN is slow would be worse than the defect.
   ========================================================================== */
(function () {
  if (window.__tdpPix) return;

  var SIZE = 128;

  /* NEAR-PURE RED: what ink is made of. Red beats both other channels by a wide
     margin and is bright enough not to be a maroon shadow or dark red leather. */
  var R_MIN = 170, GB_MAX = 90, DOM_MIN = 110;

  /* All four set from the catalogue census. Do not move one without re-running
     45-hover-content-test/analyse_rule.py and re-scoring a fresh sample. */
  var INK_MIN_PX   = 110;    /* near-pure red pixels out of 16,384 */
  var INK_THIN_MIN = 0.95;   /* share destroyed by ONE 4-neighbour erosion */
  var INK_CR_MIN   = 2.2;    /* columns touched / rows touched */
  var INK_BIG_MAX  = 0.25;   /* largest connected red blob, as a share of Sn */

  var RMS_SAME = 4.0;        /* RGB RMS below this is the same photograph */
  var COLOUR_MAX = 120;      /* mean-colour distance above this is another colourway */
  var BG_MIN = 200;          /* min(R,G,B) at or above this is studio background */

  var TIMEOUT = 4000;
  var MAX_CACHE = 600;
  var LOOK = 6;              /* candidates probed per card */

  var ctx = null;
  function ctx2d() {
    if (ctx === null) {
      try {
        var cv = document.createElement('canvas');
        cv.width = cv.height = SIZE;
        ctx = cv.getContext('2d', { willReadFrequently: true }) || false;
      } catch (e) { ctx = false; }
    }
    return ctx;
  }

  /* One 4-neighbour erosion, the same structuring element the census used. */
  function erodeCount(m) {
    var n = 0, y, x, i;
    for (y = 1; y < SIZE - 1; y++) {
      for (x = 1; x < SIZE - 1; x++) {
        i = y * SIZE + x;
        if (m[i] && m[i - 1] && m[i + 1] && m[i - SIZE] && m[i + SIZE]) n++;
      }
    }
    return n;
  }

  /* 8-connected components: how many separate red marks, and how big the
     biggest one is. Letters give many small ones; an object gives one. */
  function components(m) {
    var seen = new Uint8Array(SIZE * SIZE), stack = new Int32Array(SIZE * SIZE);
    var count = 0, biggest = 0, i, x, y, sp, cur, p, dx, dy, nx, ny, q;
    for (i = 0; i < m.length; i++) {
      if (!m[i] || seen[i]) continue;
      count++; sp = 0; stack[sp++] = i; seen[i] = 1; cur = 0;
      while (sp) {
        p = stack[--sp]; cur++;
        x = p % SIZE; y = (p - x) / SIZE;
        for (dy = -1; dy <= 1; dy++) {
          ny = y + dy; if (ny < 0 || ny >= SIZE) continue;
          for (dx = -1; dx <= 1; dx++) {
            nx = x + dx; if (nx < 0 || nx >= SIZE) continue;
            q = ny * SIZE + nx;
            if (m[q] && !seen[q]) { seen[q] = 1; stack[sp++] = q; }
          }
        }
      }
      if (cur > biggest) biggest = cur;
    }
    return { count: count, biggest: biggest };
  }

  /* Load the probe image with the codec PINNED. See the note at the top. */
  function loadBitmap(key) {
    if (typeof fetch !== 'function' || typeof createImageBitmap !== 'function') {
      return Promise.reject(0);
    }
    return fetch(key, { headers: { Accept: 'image/jpeg' }, mode: 'cors', credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw 0; return r.blob(); })
      .then(function (bl) { return createImageBitmap(bl); });
  }

  function measure(img) {
    var c = ctx2d();
    if (!c) return { ok: false };
    c.clearRect(0, 0, SIZE, SIZE);
    c.drawImage(img, 0, 0, SIZE, SIZE);        // stretched: aspect deliberately ignored
    var d = c.getImageData(0, 0, SIZE, SIZE).data;   // throws when tainted
    var N = SIZE * SIZE;
    var rgb = new Uint8Array(N * 3), mask = new Uint8Array(N), red = 0;
    var rows = new Uint8Array(SIZE), cols = new Uint8Array(SIZE);
    var cr = 0, cg = 0, cb = 0, cn = 0;
    for (var i = 0, p = 0; i < N; i++, p += 4) {
      var r = d[p], g = d[p + 1], b = d[p + 2];
      rgb[i * 3] = r; rgb[i * 3 + 1] = g; rgb[i * 3 + 2] = b;
      var mx = g > b ? g : b;
      var mn = r < g ? (r < b ? r : b) : (g < b ? g : b);
      /* the product, not the studio background */
      if (mn < BG_MIN) { cr += r; cg += g; cb += b; cn++; }
      if (r >= R_MIN && mx <= GB_MAX && (r - mx) >= DOM_MIN) {
        mask[i] = 1; red++;
        rows[(i / SIZE) | 0] = 1; cols[i % SIZE] = 1;
      }
    }
    var colour = cn >= 50 ? [cr / cn, cg / cn, cb / cn] : null;
    var ink = false, thin = 0, nr = 0, nc = 0, comp = { count: 0, biggest: 0 };
    if (red >= INK_MIN_PX) {
      thin = 1 - (erodeCount(mask) / red);
      for (var k = 0; k < SIZE; k++) { if (rows[k]) nr++; if (cols[k]) nc++; }
      comp = components(mask);
      ink = thin >= INK_THIN_MIN &&
            nc >= INK_CR_MIN * (nr || 1) &&
            comp.biggest <= INK_BIG_MAX * red;
    }
    return { ok: true, rgb: rgb, colour: colour, redPx: red, thin: thin,
             rows: nr, cols: nc, comp: comp.count, big: comp.biggest, ink: ink };
  }

  var cache = Object.create(null), order = [];
  function probeUrl(u) { return String(u || '').split('?')[0] + '?width=' + SIZE; }

  function probe(url) {
    var key = probeUrl(url);
    if (!url || key.indexOf('data:') === 0) return Promise.resolve({ ok: false });
    if (cache[key]) return cache[key];
    var pr = new Promise(function (res) {
      var done = false;
      function finish(out) {
        if (done) return;
        done = true; clearTimeout(t);
        if (out && out.ok) inkSeen[key] = out.ink ? 1 : 0;
        res(out || { ok: false });
      }
      var t = setTimeout(function () { finish({ ok: false }); }, TIMEOUT);
      loadBitmap(key).then(function (bmp) {
        var out;
        try { out = measure(bmp); } catch (e) { out = { ok: false }; }
        try { bmp.close && bmp.close(); } catch (e) {}
        finish(out);
      }).catch(function () {
        /* codec-negotiated fallback - see the note at the top of this block */
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.decoding = 'async';
        im.onload = function () {
          var out;
          try { out = measure(im); out.negotiated = true; } catch (e) { out = { ok: false }; }
          finish(out);
        };
        im.onerror = function () { finish({ ok: false }); };
        im.src = key;
      });
    });
    cache[key] = pr;
    order.push(key);
    while (order.length > MAX_CACHE) { delete cache[order.shift()]; }
    return pr;
  }

  /* Cached-AND-ink only. An un-probed image is never called ink, so a consumer
     reading this synchronously can only ever be conservative. */
  var inkSeen = Object.create(null);
  /* Tripster Developers 28 Sep (Task 9): real part photos that carry a red "where it fits" arrow.
     They are not size guides, so they are never treated as ink. */
  var HOVER_OK = /^ewp9330791791-bdb6bd99d8932019b88ce80aba0535372ef98da9-3/i;
  function knownInk(url) { return !HOVER_OK.test(base(url)) && inkSeen[probeUrl(url)] === 1; }

  function rgbRms(a, b) {
    if (!a || !b || a.length !== b.length) return -1;
    var s = 0, n = a.length;
    for (var i = 0; i < n; i++) { var d = a[i] - b[i]; s += d * d; }
    return Math.sqrt(s / n);
  }

  function colourDist(a, b) {
    if (!a || !b) return -1;
    var x = a[0] - b[0], y = a[1] - b[1], z = a[2] - b[2];
    return Math.sqrt(x * x + y * y + z * z);
  }

  function base(u) { return String(u || '').split('?')[0].split('/').pop(); }

  /* Shopify appends `_<uuid>` when a file is uploaded under a name that is
     already taken - which is exactly how SureDone's re-pushes produced the
     hublot duplicate. This decides NOTHING on its own; it only sends a
     candidate to the back of the queue so the content test rules on it last.
     Content is the test. This is the label. */
  var UUID = /_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  function uploadKey(n) {
    return String(n || '').replace(/\.[a-z0-9]+$/i, '').replace(UUID, '').toLowerCase();
  }
  function stemOf(n) { return uploadKey(n).replace(/-\d{1,3}$/, ''); }

  /* THE PICKER. Promise of the URL the hover layer should hold, or ''.
     ORDER  : same stem as the main face first, then gallery order, then
              anything that merely looks like a re-upload of the main face.
     REJECT : red-ink overlay, then same content as the main face. */
  function pickHover(list, mainFile, mainUrl) {
    var cands = [], i, f, rank;
    for (i = 0; i < list.length; i++) {
      f = base(list[i]);
      if (f === mainFile) continue;
      rank = 1;
      if (uploadKey(f) === uploadKey(mainFile)) rank = 2;
      else if (stemOf(f) === stemOf(mainFile)) rank = 0;
      cands.push({ u: list[i], f: f, rank: rank, i: i });
    }
    cands.sort(function (a, b) { return a.rank - b.rank || a.i - b.i; });
    cands = cands.slice(0, LOOK);
    if (!cands.length) return Promise.resolve('');
    return probe(mainUrl).then(function (mp) {
      var idx = 0;
      function step() {
        if (idx >= cands.length) return '';
        var c = cands[idx++];
        return probe(c.u).then(function (r) {
          if (!r.ok) {
            /* Fail open to rev 6 - except for a candidate that already looks
               like a re-upload of the main face by name. We will not guess
               about that one. */
            return c.rank === 2 ? step() : c.u;
          }
          /* Tripster Developers 28 Sep (Task 9): a few real photos carry a red "where it fits" arrow.
             They are part photos, not size guides, so they skip the ink and colour tests. */
          var okH = HOVER_OK.test(c.f);
          if (r.ink && !okH) return step();
          if (mp && mp.ok && !okH) {
            if (rgbRms(mp.rgb, r.rgb) < RMS_SAME) return step();
            var cd = colourDist(mp.colour, r.colour);
            if (cd > COLOUR_MAX) return step();   // another colourway - misinforms
          }
          return c.u;
        });
      }
      return step();
    }).catch(function () { return ''; });
  }

  /* Probe a bounded window of a gallery so the ARROW list is filtered by the
     same predicate as the hover slot. Bounded on purpose: a product here can
     carry 113 images and probing all of them on one hover would trade a
     cosmetic regression for a performance one. */
  function warm(list) {
    var jobs = [];
    for (var i = 0; i < list.length && i < LOOK; i++) jobs.push(probe(list[i]));
    return Promise.all(jobs);
  }

  window.__tdpPix = {
    probe: probe, pickHover: pickHover, warm: warm, knownInk: knownInk,
    rgbRms: rgbRms, colourDist: colourDist, stemOf: stemOf, uploadKey: uploadKey,
    base: base,
    thresholds: { SIZE: SIZE, LOOK: LOOK, RMS_SAME: RMS_SAME, COLOUR_MAX: COLOUR_MAX,
                  INK_MIN_PX: INK_MIN_PX, INK_THIN_MIN: INK_THIN_MIN,
                  INK_CR_MIN: INK_CR_MIN, INK_BIG_MAX: INK_BIG_MAX,
                  R_MIN: R_MIN, GB_MAX: GB_MAX, DOM_MIN: DOM_MIN }
  };
})();

/* ==========================================================================
   Tripster Developers 2026-08-30 (rev 2) - product card interactions.

   SUREDONE SAFETY - the governing constraint.
   Nothing here is derived, cached or stored. Every image and every variant
   mapping is read from Shopify's own live product JSON (/products/<handle>.js)
   at the moment a shopper first hovers a card. So when SureDone re-pushes a
   product and rewrites its images or variants, the very next page view reads
   the new truth. There is no theme-side mapping, no metafield and no build step
   that can fall out of sync, and nothing to re-run after a push.

   Everything degrades to "a normal product card": if the fetch fails, if the
   JSON shape changes, or if a product has one photo, no arrows are shown and
   the card behaves exactly as the app rendered it.

   Three behaviours:
     1. Colour chips painted from the same generated colour map the filter
        sidebar uses (data-option-value mirrored to data-fvalue).
     2. Hover arrows paging the product's real photos - shown ONLY once we know
        there are 2+, so a dead arrow is never presented.
     3. Clicking a colour chip swaps the card image to THAT option's variant
        image, matched by option POSITION, not by value.
   ========================================================================== */
(function () {
  if (window.__tdpCardPass) return;
  window.__tdpCardPass = true;

  var CARD = '#gf-products .spf-product-card';

  function basename(u) {
    return String(u || '').split('?')[0].split('/').pop();
  }

  /* One fetch per card, ever. Callbacks queue while it is in flight - returning
     early here was the bug that made the arrows look dead: the prefetch starts
     on mouseenter, so a click during it was silently dropped. */
  function productData(card, cb) {
    var st = card.__tdp || (card.__tdp = { data: null, loading: false, queue: [] });
    if (st.data) return cb(st.data);
    st.queue.push(cb);
    if (st.loading) return;
    var a = card.querySelector('.spf-product-card__image-wrapper');
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!m) { st.queue = []; return; }
    st.loading = true;
    fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        st.data = p;
        st.loading = false;
        var q = st.queue; st.queue = [];
        q.forEach(function (fn) { try { fn(p); } catch (e) {} });
      })
      .catch(function () { st.loading = false; st.queue = []; });
  }

  function paintSwatches(root) {
    (root || document).querySelectorAll(CARD + ' .spf-product__swatch[data-option-value]:not([data-tdp-done])')
      .forEach(function (sw) {
        sw.setAttribute('data-tdp-done', '1');
        sw.setAttribute('data-fvalue', sw.getAttribute('data-option-value'));
        var inner = sw.querySelector('.spf-product__swatch-inner') || sw;
        var cs = getComputedStyle(inner);
        var painted = cs.backgroundImage !== 'none' ||
          (cs.backgroundColor !== 'rgba(0, 0, 0, 0)' && cs.backgroundColor !== 'transparent');
        // size/finish chips ("20mm") have no colour rule - leave them as text
        if (!painted) sw.removeAttribute('data-fvalue');
      });
  }

  function setup(root) {
    (root || document).querySelectorAll(CARD).forEach(function (card) {
      var wrap = card.querySelector('.spf-product-card__image-wrapper');
      var img = card.querySelector('img.spf-product-card__image-main');
      if (!wrap || !img) return;
      /* Guard on the arrows STILL BEING THERE, not on a flag. The filter app
         re-renders a card's contents in place on every filter, sort and page
         change - the card element survives, its children do not. A flag-based
         guard therefore marked the card as wired forever while its arrows had
         been destroyed, which is why the slider died as soon as you paginated.
         This self-heals after any re-render. */
      if (wrap.querySelector('.tdp-card-nav')) return;
      card.__tdp = null;   // stale product data belongs to the old contents

      var idx = 0;

      function show(list, i) {
        if (!list || list.length < 2) return;
        idx = ((i % list.length) + list.length) % list.length;
        var src = list[idx];
        setImage(src);
      }

      /* WHY THIS WRITES TO EVERY IMAGE IN THE CARD, NOT JUST THE MAIN ONE.
         Verified in a real browser: the app's `hover-effect` cards carry TWO
         stacked images - .spf-product-card__image-main and
         .spf-product-card__image-secondary - and cross-fades them on hover. While
         the pointer is over the card (which is the only time the arrows are even
         visible) main sits at opacity 0 and SECONDARY is what the shopper sees.
         Writing to main alone changed a hidden element, so clicking an arrow did
         nothing on screen. That was invisible to headless testing, where there is
         no real hover and main stays visible - the false pass that made me report
         this fixed twice.

         Writing both keeps the app's own hover cross-fade intact and guarantees
         that whichever layer is showing is the photo we selected.

         The lazyload hooks are stripped too (gfLazyautosizes re-applies
         data-srcset on scroll/resize and would revert the swap). */
      function faces() {
        return wrap.querySelectorAll(
          'img.spf-product-card__image-main, img.spf-product-card__image-secondary');
      }

      /* Once this has run, BOTH faces hold the same file, so the app's hover
         cross-fade would fade the chosen photograph into itself. Pin it instead
         of leaving a fade that does nothing visible - same reasoning as the
         suppression in the shared block, and it keeps `visibleSrc()` pointing
         at the face that actually holds the selection. */
      function setImage(src) {
        var url = src.split('?')[0] + '?width=540';
        var G = window.__tdpGuide;
        if (G) {
          G.suppressHover(wrap,
            wrap.querySelector('img.spf-product-card__image-main'),
            wrap.querySelector('img.spf-product-card__image-secondary'));
        }
        faces().forEach(function (el) {
          el.removeAttribute('srcset');
          el.removeAttribute('data-srcset');
          el.removeAttribute('data-src');
          el.removeAttribute('data-sizes');
          el.classList.remove('gfLazyautosizes', 'lazyload', 'lazyloading');
          el.src = url;
        });
      }

      /* Read from whatever is actually on screen, not from a fixed element. */
      function visibleSrc() {
        var shown = [].slice.call(faces()).filter(function (el) {
          return getComputedStyle(el).opacity !== '0';
        })[0] || img;
        return shown.currentSrc || shown.src;
      }

      /* Sync the index to whatever is on screen, so the first arrow click always
         lands on a genuinely different photo - the displayed image is the
         variant's image, not necessarily images[0]. */
      function syncIndex(list) {
        var cur = basename(visibleSrc());
        var at = list.map(basename).indexOf(cur);
        if (at > -1) idx = at;
      }

      // ---- arrows, revealed only when the product really has 2+ photos
      var prev = document.createElement('button');
      var next = document.createElement('button');
      prev.type = next.type = 'button';
      prev.className = 'tdp-card-nav tdp-card-nav--prev';
      next.className = 'tdp-card-nav tdp-card-nav--next';
      prev.setAttribute('aria-label', 'Previous photo');
      next.setAttribute('aria-label', 'Next photo');
      prev.innerHTML = '&#8249;';
      next.innerHTML = '&#8250;';
      wrap.appendChild(prev);
      wrap.appendChild(next);

      /* JOB 1, retainer task #9. THE ARROW LIST IS FILTERED BY THE SAME
         PREDICATE AS THE HOVER SLOT - window.__tdpGuide.isGuideUrl - not by a
         second copy of the rule. Rev 2 cleaned the hover slot and left this
         list raw, so one click on our own next arrow landed on the measurement
         guide on 1 of 28 cards on the client's page and 14 of 241 on
         /collections/all.

         If filtering leaves fewer than two photographs the caller's own
         `list.length < 2` guard hides the arrows and the card is left exactly
         as the app rendered it. That is deliberate: a product whose only extra
         media is a ruler has nothing to page to, and offering a dead arrow was
         the complaint before this one. */
      function images(p) {
        var G = window.__tdpGuide, P = window.__tdpPix;
        var list = G ? G.photosOf(p)
                     : (p && p.images ? p.images : []).filter(Boolean);
        if (!P) return list;
        /* Tripster Developers 2026-09-19 (rev 7). QA's ruling: the rule cannot
           call an image a guide when it sits on a pinned card and a real photo
           when it sits on a minted one. So the ARROW list drops the red-overlay
           images too - the same predicate, in the same place, for both jobs.
           `knownInk` is cached-AND-proven only, so before the probes land this
           is byte-for-byte the rev 6 list and the arrows behave exactly as QA
           measured them. And a product whose every photograph is an overlay
           keeps its list rather than being left with nothing to show. */
        var clean = list.filter(function (u) { return !P.knownInk(u); });
        return clean.length ? clean : list;
      }

      /* The photograph the hover layer should hold: the first real one that is
         not what the main face is already showing. */
      function otherThan(list, file) {
        for (var i = 0; i < list.length; i++) {
          if (basename(list[i]) !== file) return list[i];
        }
        return '';
      }

      /* JOB 2, retainer task #25, acceptance G25: "Hover on a collection card
         shows a REAL SECOND PHOTO of the part".

         The hover backstop further down this file can only ever repair the
         hover layer FROM THE DOM, and the only other picture in a card's DOM is
         the card's own main photograph - so its repair produces a cross-fade
         from a photo to itself. This is the one place in the theme that knows
         the product's real gallery, because it has already fetched
         /products/<handle>.js for the arrows. So when a card is sitting on a
         suppressed hover (or on a hover layer that duplicates the main face),
         and the gallery does contain a second non-guide photograph, put that
         photograph in the hover layer and let the cross-fade run.

         Only the hover layer is written here. Writing both faces - which
         setImage must do, for the reason documented above it - is what makes a
         hover a no-op in the first place. */
      /* Tripster Developers 2026-09-19 (rev 6) - A CARD WITH NO SECOND LAYER
         GETS A REAL SECOND PHOTOGRAPH, NOT A PIN.

         Rev 5 stopped the white tile on these cards by pinning the one real
         layer visible, and QA confirmed 0 blanks. But G25 is two clauses, not
         one - "hover shows A REAL SECOND PHOTO of the part, not the measurement
         guide" - and a pinned card satisfies only the second. Measured by QA on
         all 28: rest and hover render the identical file, and the entire tile-ink
         delta on the Cartier card (29.079% -> 31.897%) was our own two arrow
         controls appearing.

         The card's own gallery is not the problem. The theme already agrees a
         second real photograph exists: `data-tdp-multi="1"` is set from
         `list.length > 1` on the guide-filtered gallery, and it was set on 28 of
         28. What is missing is only the ELEMENT to put it in - Globo renders
         `.spf-product-card__image-secondary` onto layer 1, so when the card's
         variant image IS layer 1 the two roles collide on one node and only
         `-main` survives (see the rev 5 note further down this file).

         So mint the element. Cloning the MAIN img is what makes this safe:
           * the clone starts on a photograph that has already painted, so there
             is no frame in which the hover layer is empty - the worst case is a
             cross-fade to the same photo, which is rev 5's behaviour;
           * everything downstream already handles it - `faces()`, `setImage()`,
             the arrows and the hover backstop all select on the -secondary
             class, so the same machinery that serves the other 17,228 products
             serves these;
           * it is keyed on the STRUCTURE of the card (no secondary element),
             never on a handle, a collection or an image shape.

         Nothing is minted unless the gallery really holds an alternative
         photograph AND the main face has painted. If either is false the card
         keeps rev 5's pin, which is the correct answer for a product with one
         usable photo. A Globo re-render destroys the clone and restores the
         pin; the next hover mints it again. */
      function mintSecondary(mainImg) {
        if (!mainImg || !mainImg.parentNode) return null;
        /* A clone is only ever as good as what it clones. If the main face is
           still on its 1x1 lazyload placeholder, cloning it mints exactly the
           blank tile this task exists to remove - so don't. The card keeps its
           pin and a later hover mints it once main is real. */
        var cur = mainImg.currentSrc || mainImg.getAttribute('src') || '';
        if (!cur || cur.indexOf('data:') === 0) return null;
        if ((mainImg.naturalWidth || 0) <= 1) return null;
        var el = mainImg.cloneNode(false);
        /* Keep `spf-product-card__image` - it carries the app's absolute
           positioning AND the `img.spf-product-card__image.spf-product-card__
           image-secondary { opacity:0!important }` rest state, without which
           the new layer would sit on top of the card permanently. Drop
           `-main`, `-hidden` and every lazyload hook. */
        el.className = 'spf-product-card__image spf-product-card__image-secondary';
        /* Globo's swatch handler selects on `[data-variants*=<id>]` and would
           otherwise find two nodes claiming to be the variant's image. */
        el.removeAttribute('id');
        el.removeAttribute('data-variants');
        el.removeAttribute('data-src');
        el.removeAttribute('data-original');
        el.removeAttribute('data-srcset');
        el.removeAttribute('data-sizes');
        el.removeAttribute('srcset');
        el.removeAttribute('sizes');
        el.removeAttribute('data-tdp-hover-fixed');
        el.removeAttribute('data-tdp-guide-hidden');
        el.removeAttribute('data-tdp-hover-real');
        el.style.removeProperty('display');
        el.style.removeProperty('opacity');
        el.setAttribute('src', cur);
        el.setAttribute('data-tdp-minted', '1');
        mainImg.parentNode.insertBefore(el, mainImg.nextSibling);
        return el;
      }

      /* Write the chosen photograph into the hover layer. Unchanged from rev 6
         except that it is now only ever reached with a photograph that has
         been looked at. */
      function writeHover(secImg, mainImg, alt) {
        var G = window.__tdpGuide;
        secImg.removeAttribute('srcset');
        secImg.removeAttribute('data-srcset');
        secImg.removeAttribute('data-src');
        secImg.removeAttribute('data-sizes');
        secImg.classList.remove('gfLazyautosizes', 'lazyload', 'lazyloading');
        var fallback = G.fileOf(mainImg) && mainImg.currentSrc ? mainImg.currentSrc : '';
        secImg.onerror = function () {
          secImg.onerror = null;
          secImg.removeAttribute('data-tdp-hover-real');
          if (fallback) secImg.src = fallback;      // never leave a broken tile
          G.suppressHover(wrap, mainImg, secImg);
        };
        secImg.src = alt.split('?')[0] + '?width=540';
        secImg.setAttribute('data-tdp-hover-real', '1');
        G.releaseHover(wrap, mainImg, secImg);
      }

      /* Tripster Developers 2026-09-19 (rev 7) - DECIDE FIRST, MINT SECOND.

         Rev 6 minted the hover element and THEN worked out what to put in it.
         On the hublot card the answer turned out to be a re-upload of the very
         photograph already on screen, so the shopper got a cross-fade to
         nothing - a different FILE, the same PICTURE. The photograph is now
         settled, pixels included, before any DOM node is created, and if no
         candidate survives the content test the card keeps rev 5's pin, which
         is the honest answer for a product with one usable photo. */
      function promoteHover(list) {
        var G = window.__tdpGuide;
        if (!G) return;
        var P = window.__tdpPix;
        var mainImg = wrap.querySelector('img.spf-product-card__image-main');
        if (!mainImg) return;
        var secImg = wrap.querySelector('img.spf-product-card__image-secondary');
        var mainFile = G.fileOf(mainImg);
        var secFile = secImg ? G.fileOf(secImg) : '';
        var needs = !secImg || !secFile || secFile === mainFile ||
                    G.isGuideName(secFile) ||
                    wrap.getAttribute('data-tdp-hover-off') === '1';
        if (!needs) return;
        var mainUrl = mainImg.currentSrc || mainImg.getAttribute('src') || '';
        var chosen = P ? P.pickHover(list, mainFile, mainUrl)
                       : Promise.resolve(mainFile ? otherThan(list, mainFile)
                                                  : (list[1] || list[0] || ''));
        chosen.then(function (alt) {
          /* Globo re-renders the grid client-side on every filter, sort and
             page change; by the time the probes land these nodes may be gone.
             Writing to a detached image is silent and useless, so stop. */
          if (!mainImg.parentNode) return;
          var sec = wrap.querySelector('img.spf-product-card__image-secondary');
          if (!alt) { G.suppressHover(wrap, mainImg, sec); return; }
          if (!sec) {
            sec = mintSecondary(mainImg);
            if (!sec) { G.suppressHover(wrap, mainImg, null); return; }
          }
          if (faces().length < 2) return;
          writeHover(sec, mainImg, alt);
        }).catch(function () {});
      }

      function reveal(p) {
        var list = images(p);
        // data-tdp-multi gates the arrows in CSS - no flash of a dead control
        if (list.length > 1) wrap.setAttribute('data-tdp-multi', '1');
        syncIndex(list);
        try { promoteHover(list); } catch (e) {}
        /* rev 7: once the content probes for this card's first few photographs
           have landed, re-settle the arrow gate against the ink-filtered list.
           Every arrow click re-derives the list itself, so this only has to fix
           the gate - and it never widens it, it can only close it. */
        var P = window.__tdpPix;
        if (!P) return;
        P.warm(list).then(function () {
          if (!wrap.parentNode) return;
          var clean = images(p);
          if (clean.length === list.length) return;
          if (clean.length > 1) wrap.setAttribute('data-tdp-multi', '1');
          else wrap.removeAttribute('data-tdp-multi');
          syncIndex(clean);
        }).catch(function () {});
      }

      wrap.addEventListener('mouseenter', function () { productData(card, reveal); });
      // touch devices never fire mouseenter
      wrap.addEventListener('touchstart', function () { productData(card, reveal); }, { passive: true });

      function arm(btn, dir) {
        // the arrows sit inside the card's product <a>; stop it navigating
        ['mousedown', 'pointerdown'].forEach(function (evt) {
          btn.addEventListener(evt, function (e) { e.preventDefault(); e.stopPropagation(); }, { passive: false });
        });
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          productData(card, function (p) {
            var list = images(p);
            if (list.length < 2) return;
            if (!wrap.hasAttribute('data-tdp-multi')) reveal(p);
            // the hover cross-fade has finished by now, so this is the first
            // moment the visible layer is genuinely what the shopper sees
            syncIndex(list);
            show(list, idx + dir);
          });
        });
      }
      arm(prev, -1);
      arm(next, 1);

      // ---- colour chip -> that option's variant image, matched by POSITION
      card.querySelectorAll('.spf-product__swatch[data-option-value]:not([data-tdp-chip])').forEach(function (chip) {
        chip.setAttribute('data-tdp-chip', '1');
        chip.addEventListener('click', function () {
          productData(card, function (p) {
            var value = String(chip.getAttribute('data-option-value') || '').trim().toLowerCase();
            /* data-option is the option's 1-based position. Matching on position
               rather than on any-option is what keeps Band Color "Black" from
               picking up a variant whose BUCKLE colour happens to be Black. */
            var pos = parseInt(chip.getAttribute('data-option'), 10);
            var oi = isNaN(pos) ? -1 : pos - 1;
            function atPosition(v) {
              var opts = v.options || [];
              if (oi > -1 && oi < opts.length) {
                return String(opts[oi]).trim().toLowerCase() === value;
              }
              return opts.some(function (o) { return String(o).trim().toLowerCase() === value; });
            }
            var matches = (p.variants || []).filter(atPosition);
            /* Audited live: on this catalogue some variants carry no image of
               their own. Prefer the exact variant's image, then the first
               same-option variant that has one. If nothing in that option has an
               image there is genuinely nothing truthful to show, so the current
               photo stays rather than swapping to an unrelated colour. */
            /* Tripster Developers 2026-09-18 (rev 4) - THE CHIP IS A CONSUMER
               OF THE GUIDE PREDICATE TOO. It reached setImage() with whatever
               featured_image the variant carried and no guide test at all, so a
               variant whose featured image is a measurement guide would put the
               guide into the card on a single chip click. Measured over 400
               products / 949 variants that carry a featured image, nothing
               currently lands on one - this is latent, not live - but it is the
               one path in the file that could still do it, and an unguarded
               path is exactly how the arrow list broke in rev 2.

               A guide-featured variant is SKIPPED rather than shown, which
               falls straight through to the same-option fallback below and then
               to "leave the current photograph alone" - the honest answer the
               no-image case already gives. */
            var GC = window.__tdpGuide;
            var withImg = matches.filter(function (v) {
              var fi = v.featured_image;
              if (!fi || !fi.src) return false;
              return !(GC && GC.isGuide(fi.src, fi.width, fi.height));
            })[0];
            var src = withImg && withImg.featured_image.src;
            if (!src) return;
            setImage(src);
            syncIndex(images(p));   // arrows continue from the image now shown
          });
        });
      });
    });
  }

  /* A chip row that overflows gets a trailing fade so the cut edge reads as
     "more to scroll" rather than as a broken label. Measured on the live grid:
     4 of 7 rows overflow, the worst at 367px inside a 192px track. */
  function markOverflow(root) {
    (root || document).querySelectorAll(CARD + ' .spf-product__swatchs').forEach(function (row) {
      if (row.scrollWidth > row.clientWidth + 1) row.setAttribute('data-tdp-over', '1');
      else row.removeAttribute('data-tdp-over');
    });
  }

  function run() { paintSwatches(); setup(); markOverflow(); }
  window.addEventListener('resize', function () { markOverflow(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  /* The filter app replaces #gf-products wholesale on every filter, sort and page
     change. Debounced so a burst of mutations costs one pass, not hundreds. */
  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(run, 60);
  }).observe(document.body, { childList: true, subtree: true });
})();

/* ==========================================================================
   Tripster Developers 2026-08-30 - model-number search rescue (client P12:
   "be sure that the search bar picks up listings that have model numbers under
   our header compatible model, compatible model 2, 3, 4, 5").

   THE GAP, MEASURED: SureDone spreads compatible models across five fields.
   Only the first reliably reaches the Shopify description, so 512 products carry
   model numbers that exist nowhere Shopify's search can see - not in the title,
   not in the body. Searching those numbers returns nothing.

   WHY IT IS SOLVED HERE AND NOT BY WRITING TO THE PRODUCT
   Shopify only indexes title / description / vendor / product_type / tags, and
   SureDone owns every one of those - anything written there is erased on the next
   push. So the numbers live in metafield tdp.compat_models (rendered on the PDP,
   which is what Google reads) and this index rescues ON-SITE search.

   FAILS SAFE: the index is fetched only on the search page, and only when the
   query looks like a model number AND Shopify returned few results. If the file
   is missing, stale, or the model is unknown, nothing happens and the shopper
   sees exactly the normal Shopify result - never an error, never a blank page.
   Regenerate with 09-model-search/build_model_search.py after a big import.
   ========================================================================== */
(function () {
  if (!/\/search/.test(location.pathname)) return;

  var params = new URLSearchParams(location.search);
  var q = (params.get('q') || '').trim();
  if (!q) return;

  // only model-shaped queries: has a digit, no spaces, 4-24 chars
  if (q.length < 4 || q.length > 24 || /\s/.test(q) || !/\d/.test(q)) return;

  /* Which products is the shopper already being shown? Measured: Shopify DOES
     return results for a model query (10 for "116200") - it just misses the
     specific products whose model lives only in compatiblemodelcont2..5. So the
     rescue must surface what is MISSING, not fire only when the page is empty. */
  function shownHandles() {
    var set = {};
    document.querySelectorAll('#gf-products a[href*="/products/"], .product-grid a[href*="/products/"]')
      .forEach(function (a) {
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (m) set[m[1]] = true;
      });
    return set;
  }

  function render(handles) {
    if (!handles || !handles.length) return;
    var host = document.querySelector('#gf-products, .product-grid, main');
    if (!host) return;
    var box = document.createElement('div');
    box.className = 'tdp-model-rescue';
    box.innerHTML =
      '<p class="tdp-model-rescue__head">Also listed as compatible with <strong>' +
      q.replace(/[<>&]/g, '') + '</strong></p><ul class="tdp-model-rescue__list"></ul>';
    var ul = box.querySelector('ul');
    handles.slice(0, 12).forEach(function (h) {
      fetch('/products/' + h + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var li = document.createElement('li');
          var img = (p.images && p.images[0]) ? p.images[0].split('?')[0] + '?width=200' : '';
          li.innerHTML =
            '<a href="/products/' + h + '">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy" width="90" height="90">' : '') +
            '<span class="tdp-model-rescue__title">' + p.title + '</span>' +
            '<span class="tdp-model-rescue__price">$' + (p.price / 100).toFixed(2) + '</span></a>';
          ul.appendChild(li);
        })
        .catch(function () {});
    });
    host.parentNode.insertBefore(box, host);
  }

  // give Shopify/the filter app a moment to place its own results first
  setTimeout(function () {
    if (!window.tdpModelIndexUrl) return;
    fetch(window.tdpModelIndexUrl)
      .then(function (r) { return r.json(); })
      .then(function (idx) {
        var hit = idx[q.toUpperCase()];
        if (!hit || !hit.length) return;
        var already = shownHandles();
        var missing = hit.filter(function (h) { return !already[h]; });
        // everything relevant is already on the page - stay out of the way
        if (!missing.length) return;
        render(missing);
      })
      .catch(function () {});
  }, 1400);
})();

/* ==========================================================================
   Tripster Developers 2026-09-26 - SKU search rescue (retainer task 56:
   "search on Shopify site to search by sku").

   THE GAP, MEASURED: the Smart Filter & Search app indexes only the first 100
   variants of a product. 226 products have more, so about 23,000 SKUs (variant
   101 and up) return nothing in the app's search.

   Shopify's own predictive search indexes EVERY variant SKU
   (/search/suggest.json, fields=variants.sku) - verified on EWP933021211 and
   EWP933035307, both missed by the app and both found by Shopify.

   So on the search page, a SKU-shaped query asks Shopify which product owns
   that exact SKU and opens it with that variant selected. Exact match only;
   anything else (no hit, several products, network error) leaves the normal
   search results exactly as they are.
   ========================================================================== */
(function () {
  if (!/\/search/.test(location.pathname)) return;
  var q = (new URLSearchParams(location.search).get('q') || '').trim();
  // SKU-shaped: one token, 5-20 chars, letters/digits/hyphen, at least 3 digits
  if (!/^[A-Za-z0-9-]{5,20}$/.test(q) || (q.match(/\d/g) || []).length < 3) return;
  var want = q.toUpperCase();
  fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=4&resources[options][fields]=variants.sku')
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var ps = (((d || {}).resources || {}).results || {}).products || [];
      return Promise.all(ps.slice(0, 4).map(function (p) {
        return fetch('/products/' + p.handle + '.js').then(function (r) { return r.json(); })
          .then(function (full) {
            var v = (full.variants || []).filter(function (x) {
              return (x.sku || '').toUpperCase() === want;
            })[0];
            return v ? { handle: p.handle, id: v.id } : null;
          }).catch(function () { return null; });
      }));
    })
    .then(function (hits) {
      hits = (hits || []).filter(Boolean);
      if (hits.length !== 1) return;          // none, or ambiguous: stay on results
      location.replace('/products/' + hits[0].handle + '?variant=' + hits[0].id);
    })
    .catch(function () {});
})();

/* ==========================================================================
   Sale week: hide the Discount Mixer's UPSELL messaging (product page + cart)
   Tripster Developers 2026-09-10, client request.

   The PDP advertises "Buy 2pcs get 2% off / Buy 3pcs get 4% off" from the
   Discount Mixer app. During the relaunch campaign the Miko function gives 10%
   storewide and wins every one of those tiers at checkout (measured at qty
   1/2/3/4/6/10 - all exactly 10%). Leaving the box up tells a shopper the best
   available deal is 2%, which is both wrong and worse than what they will
   actually be charged.

   THE POINT OF DOING IT THIS WAY: it restores itself. The window is hard-coded
   to the campaign, so the box comes back on its own the moment the sale ends.
   Nobody has to remember to switch it on, and if everyone forgets this file
   entirely it still behaves correctly from 21 Sep onward. A manual toggle is
   how a one-week change quietly becomes permanent.

   Window, matching the campaign row exactly:
     start  2026-09-14T14:00:00Z  = Mon 14 Sep 09:00 America/Chicago
     end    2026-09-21T04:59:00Z  = Sun 20 Sep 23:59 America/Chicago
   UTC on both sides so the visitor's own clock/zone cannot shift it.
   ========================================================================== */
(function () {
  var START = Date.UTC(2026, 8, 14, 14, 0, 0);
  var END   = Date.UTC(2026, 8, 21, 4, 59, 0);

  function saleWeek() {
    var now = Date.now();
    return now >= START && now < END;
  }

  // Only the Mixer's UPSELL wording. Deliberately not the class on its own:
  // `li.discount-cart` is also what the cart uses for a discount that is actually
  // applied, and during the sale that line is the 10% the customer is getting.
  // Hiding it would hide their own saving from them.
  var UPSELL = /buy\s*\d+\s*(pcs?|pieces?)?\s*get\s*\d/i;

  function toggle(el, on) {
    if (!el) return;
    if (on) {
      if (el.getAttribute('data-tdp-sale-hidden') !== '1') {
        el.setAttribute('data-tdp-sale-hidden', '1');
        el.style.display = 'none';
      }
    } else if (el.getAttribute('data-tdp-sale-hidden') === '1') {
      el.removeAttribute('data-tdp-sale-hidden');
      el.style.display = '';
    }
  }

  function apply() {
    var on = saleWeek();

    // 1. Product page: the "Bulk discount offers" block.
    //    The app injects .offer late and can re-render it, so this both hides and
    //    UNHIDES every pass rather than assuming a one-way transition.
    var offers = document.querySelectorAll('.offer');
    for (var i = 0; i < offers.length; i++) {
      // Hide the whole theme block, not just the app's div, or the block's own
      // padding leaves a visible empty card where the box used to be.
      toggle(offers[i].closest('.product-info__block-item') || offers[i], on);
    }

    // 2. Cart page and cart drawer: the per-line "Buy 2 get 2% off" chip.
    //    Text-matched, so a real applied discount on the same element survives.
    var chips = document.querySelectorAll('li.discount-cart, .discount-cart');
    for (var j = 0; j < chips.length; j++) {
      var c = chips[j];
      if (UPSELL.test(c.textContent || '')) toggle(c, on);
      else toggle(c, false); // never leave a genuine discount line hidden
    }
  }

  function start() {
    apply();
    // The box is app-injected, so catch it whenever it lands.
    try {
      new MutationObserver(function () {
        clearTimeout(window.__tdpOfferT);
        window.__tdpOfferT = setTimeout(apply, 120);
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    // And cross the boundary without a reload for anyone sitting on the page.
    setInterval(apply, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   Tripster Developers 2026-09-15 - SALE POP-UP, client request #2
   "Can we create a pop up to show 10% off storewide? Currently its just top
    banner and you cannot see it."

   He is right, and it is measurable. The campaign bar is 40px tall on desktop
   and 14px type, which is 4.4% of the first screen, stacked under the trust bar
   and the free-shipping bar. On a phone it is 7%. Three stacked strips of small
   text read as chrome, not as an offer.

   RULES THIS THING FOLLOWS, because a pop-up is the easiest way to make a store
   worse:
     - once per visitor per day, remembered in localStorage
     - never on /cart or /checkouts. Nobody interrupts a shopper who is buying
     - 1.6s delay, so it never competes with first paint or shifts layout
     - Escape closes it, the backdrop closes it, focus goes to the dialog and
       returns to where it was, and it is a real aria dialog
     - honours prefers-reduced-motion
     - it expires with the campaign. Same hard-coded window as the upsell
       suppression above, so the moment the sale ends this is inert whether or
       not anyone remembers this file exists

   Storage can throw outright in private mode, so every read and write is
   wrapped: a pop-up that 500s the page for a shopper is worse than no pop-up.
   ========================================================================== */
(function () {
  var START = Date.UTC(2026, 8, 14, 14, 0, 0);
  var END   = Date.UTC(2026, 8, 21, 4, 59, 0);
  var KEY   = 'tdpSaleModalSeen';
  var DELAY = 1600;

  var now = Date.now();
  if (now < START || now >= END) return;

  var path = window.location.pathname;
  if (path.indexOf('/cart') === 0 || path.indexOf('/checkouts') === 0) return;

  function seenToday() {
    try {
      var v = window.localStorage.getItem(KEY);
      return !!v && (Date.now() - parseInt(v, 10)) < 864e5;
    } catch (e) { return false; }
  }
  function remember() {
    try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }
  if (seenToday()) return;

  // "Ends Sunday" is true for the whole window, and a live day count that says
  // "1 day left" on the last morning is more honest than a fixed line.
  function endsCopy() {
    // A countdown is only worth showing when it is short enough to be urgent.
    // Math.ceil made day one of a seven day sale read "7 days left", which is
    // both slightly wrong and not persuasive. State the deadline instead, and
    // only count down over the last two days.
    var left = END - Date.now();
    if (left <= 864e5) return 'Last day. Ends tonight at 11:59 PM Central.';
    if (left <= 1728e5) return 'Ends tomorrow, 11:59 PM Central.';
    return 'Ends Sunday 20 September, 11:59 PM Central.';
  }

  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'tdp-sale-modal';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'tdp-sale-modal-title');
    wrap.innerHTML =
      '<div class="tdp-sale-modal__backdrop" data-tdp-close></div>' +
      '<div class="tdp-sale-modal__card" tabindex="-1">' +
        '<button type="button" class="tdp-sale-modal__x" data-tdp-close aria-label="Close">&times;</button>' +
        '<div class="tdp-sale-modal__eyebrow">The new eWatch Parts is open</div>' +
        '<div class="tdp-sale-modal__big" id="tdp-sale-modal-title">10% off</div>' +
        '<div class="tdp-sale-modal__sub">the entire store</div>' +
        '<div class="tdp-sale-modal__rule"></div>' +
        '<p class="tdp-sale-modal__body">' +
          '<strong>No coupon code required.</strong> We have automated it for you. ' +
          'The 10% is already off every price, and off again at checkout.' +
        '</p>' +
        '<a class="tdp-sale-modal__cta" href="/collections/all">Shop the sale</a>' +
        '<button type="button" class="tdp-sale-modal__no" data-tdp-close>No thanks, just browsing</button>' +
        '<div class="tdp-sale-modal__fine">' + endsCopy() + '</div>' +
      '</div>';
    return wrap;
  }

  function show() {
    if (document.querySelector('.tdp-sale-modal')) return;
    var opener = document.activeElement;
    var el = build();
    document.body.appendChild(el);
    // next frame so the opening transition actually runs
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    var card = el.querySelector('.tdp-sale-modal__card');
    // focus() before layout is a no-op on a freshly appended node, so this runs
    // on the next frame and falls back to the first control if the card refuses.
    requestAnimationFrame(function () {
      try {
        card.focus({ preventScroll: true });
        if (!card.contains(document.activeElement) && document.activeElement !== card) {
          var f = el.querySelector('.tdp-sale-modal__cta');
          if (f) f.focus({ preventScroll: true });
        }
      } catch (e) {}
    });
    remember();

    function close() {
      el.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      window.setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
        try { if (opener && opener.focus) opener.focus(); } catch (e) {}
      }, 220);
    }
    function onKey(e) {
      if (e.key === 'Escape' || e.keyCode === 27) { close(); return; }
      if (e.key !== 'Tab') return;
      // keep focus inside the dialog while it is open
      var f = el.querySelectorAll('a[href],button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    el.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-tdp-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', onKey);
  }

  function arm() { window.setTimeout(show, DELAY); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();

/* ==========================================================================
   Tripster Developers 2026-09-18 - THE HOVER IMAGE MUST NEVER BE A GUIDE,
   AND IT MUST NEVER BE BLANK.  Retainer tasks #9 and #25.

   #9  "When you hover over any item it shows the measurement guide as the next
        image; possible to get it to code so it goes to media 3 vs media 2 as
        every measurement guide is on media 2"
   #25 "Task 9 above is not done; now when you hover the arrow shows but shows
        white blank image"

   WHAT THE 2026-09-15 VERSION OF THIS BLOCK GOT WRONG
   ---------------------------------------------------
   It found guides by FILENAME (`mg_<digits>`, `guid`, `measure`) and then hid
   them with `display:none`.  Two separate faults, both measured on the live
   site today:

   1. THE NAME TEST CANNOT SEE MOST GUIDES.  The guides QA found on
      /collections/watch-bands-for-omega are uploaded as
      `ewp<sku>-<hex>-2.png` - named exactly like a product photograph.  10 of
      the 23 hover images on that page were guides and not one of them matched
      the regex.  Guides are only identifiable by their CONTENT: the same
      graphic is re-uploaded once per product, so identical files share
      (mimeType, width, height, fileSize).  148 such images were labelled by
      eye; the hashes below are the ones that can still reach a hover slot.

   2. `display:none` ON THE HOVER IMAGE IS WHAT PRODUCED THE WHITE BLANK.
      The collection grid is re-rendered client-side by the Globo filter app,
      and its own stylesheet says:
         .spf-product-card__image-wrapper.hover-effect:hover
             .spf-product-card__image-main      { opacity: 0 !important }
             .spf-product-card__image-secondary { opacity: 1 !important }
      Hiding the secondary does not stop the main image fading out.  The card
      fades to nothing and the shopper sees a white tile - exactly item #25.
      173 published products still carry an `MG_*` guide in media slot 2, so
      this was live on every one of their cards.

   SO: never hide anything.  If the hover image is a guide, point it at the
   card's MAIN photograph instead.  Hover then cross-fades to the product,
   which is the worst case, instead of to a ruler or to nothing.

   Handles both grids: the theme's own `<product-card>` (used on
   /collections/all, /collections/bezel-inserts and search) and Globo's
   `.spf-product-card` (used wherever a filter set is configured, e.g.
   /collections/watch-bands-for-omega).

   This is a PRESENTATION backstop only.  The real fix is the media order in
   Shopify - 31-hover-guide/demote_guides_v2.py moved the guides to the end of
   the gallery on every product that has a second real photograph.  These
   hashes cover the products that have only ONE real photograph, where there is
   nothing else to promote.  Regenerate with 31-hover-guide/iterate.py if the
   catalogue changes.
   ========================================================================== */
(function () {
  /* THE PREDICATE IS NOT DEFINED HERE ANY MORE. It moved to the shared block at
     the top of this file (2026-09-18 rev 3) so that this backstop and the arrow
     list cannot drift apart again - which is exactly how task #9 came back.
     These are one-line delegations, on purpose: there is nothing here to keep
     in step with anything. */
  var G = window.__tdpGuide;
  function fileOf(img) { return G ? G.fileOf(img) : ''; }
  /* Tripster Developers 2026-09-18 (rev 4): named isGuideEl, not isGuide. The
     shared block now exports isGuide(src, w, h) - a DIFFERENT signature - and a
     local function of the same name in this IIFE would shadow it, so anyone who
     later wrote isGuide(src, w, h) in here would silently get the element form
     and a wrong answer. Distinct shapes get distinct names. */
  function isGuideEl(img) { return G ? G.isGuideImg(img) : false; }

  /* Tripster Developers 2026-09-18 (rev 2) - retainer task #25.

     MEASURED DEFECT IN REV 1, on the client's OWN page
     (/collections/watch-bands-for-omega, Globo grid, 24 cards rendered):

       live theme 154045186187 : 21 real photo, 2 GUIDE on hover, 0 blank
       rev 1      154080444555 : 21 real photo, 2 BLANK  on hover, 0 guide

     Rev 1 turned his two remaining rulers into two empty white tiles with our
     arrows sitting on them - the exact sentence he has already sent us twice.
     Both cards ended up with `data-tdp-hover-fixed="1"` and `naturalWidth === 1`.

     WHY. Rev 1 accepted the SOURCE's `data-srcset` as "something real to copy",
     wrote it to the target, and in the same pass deleted the target's own
     `data-src` / `data-srcset`. On a card whose main photo had not painted yet
     that handed the browser a 1x1 placeholder and removed every route by which
     Globo's lazyloader could ever fill it. The tile could then never recover,
     because the memo flag said the card was already fixed and the observer
     watches childList only - a lazyloader flipping `src` on an existing <img>
     fires nothing.

     SO, three rules:
       1. Copy only a URL that is ALREADY RESOLVED (`currentSrc`, or a non-data
          `src`). A lazyload template is not an image.
       2. Mark the target fixed only on SUCCESS, and treat the mark as spent if
          the element is still showing a placeholder - guard on the STATE, never
          on the flag alone. (Same lesson as the arrows: guard on the thing
          still being there.)
       3. Keep re-checking. Late passes are what catch an image that resolved
          after the first sweep.  */

  function resolvedSrc(img) {
    if (!img) return '';
    var s = img.currentSrc || '';
    if (s && s.indexOf('data:') !== 0) return s;
    s = img.getAttribute('src') || '';
    if (s && s.indexOf('data:') !== 0) return s;
    return '';
  }

  // Is this element actually showing a picture right now?
  function painted(img) {
    return !!img && !!resolvedSrc(img) && (img.naturalWidth || 0) > 1;
  }

  function adopt(target, source) {
    if (!target || !source || target === source) return false;
    // Already adopted AND actually showing something: nothing to do.
    if (target.getAttribute('data-tdp-hover-fixed') === '1' && painted(target)) return false;
    var url = resolvedSrc(source);
    if (!url) return false;            // source has not painted yet - a later pass will
    var ss = source.getAttribute('srcset') || '';
    var sizes = source.getAttribute('sizes');
    target.setAttribute('src', url);
    if (ss) target.setAttribute('srcset', ss);
    else target.removeAttribute('srcset');
    if (sizes) target.setAttribute('sizes', sizes);
    // The lazyloader would otherwise put its own data-srcset back over this.
    target.removeAttribute('data-src');
    target.removeAttribute('data-original');
    target.removeAttribute('data-srcset');
    target.removeAttribute('data-sizes');
    if (target.classList) {
      target.classList.remove('gfLazyautosizes', 'lazyload', 'lazyloading');
    }
    // Undo the 2026-09-15 behaviour if a cached copy of that script ran first.
    target.style.removeProperty('display');
    target.removeAttribute('data-tdp-guide-hidden');
    target.setAttribute('data-tdp-hover-fixed', '1');
    return true;
  }

  // An <img> we already touched that is still on a 1x1 placeholder.
  function stalled(img) {
    return img.getAttribute('data-tdp-hover-fixed') === '1' && !painted(img);
  }

  /* Task #25's acceptance is "a REAL SECOND PHOTO", so this has three outcomes,
     not two:

       secondary is a real, different photograph  -> leave it, release any pin
       secondary is a guide, blank, or the SAME
         file as the main photograph              -> repair it from the main
                                                     photograph so it can never
                                                     be blank, AND pin the two
                                                     layers so the card simply
                                                     does not react to hover
       both faces are guides                      -> leave the card alone

     The middle case used to end at "repair it", which is how 7 of 28 cards on
     the client's page came to cross-fade a photograph into itself. The pin is
     lifted again by promoteHover() in the card-interaction block as soon as the
     product's own gallery turns out to hold a second real photograph. */
  function wrapperOf(img) {
    if (!img || !img.closest) return null;
    return img.closest('.spf-product-card__image-wrapper') ||
           img.closest('product-card') || img.closest('.product-card');
  }

  function fixCard(main, secondary) {
    if (!main) return;
    /* Tripster Developers 2026-09-18 (rev 5) - THE CARD WITH NO SECOND LAYER.

       QA measured, on the live MAIN theme, a card that hovers to 0.522% tile
       ink - below the 1.086% blank threshold, against 8.808% for the dimmest
       real photograph in the catalogue:
         /products/15mm-leather-watch-strap-band-for-lady-cartier-roadster-
         2675-2723-quick-blue

       It is NOT "only one image layer", which is what I reported earlier and
       what this early return assumed. The card renders FIVE
       `.spf-product-card__image` elements and the product has four usable
       photographs. Four of the five are Globo placeholders that never hydrate
       (1x1 data GIF, class `spf-product-card__image-hidden`, which the app's
       own stylesheet sets to `display:none!important`), and there is
       NO `.spf-product-card__image-secondary` ELEMENT ANYWHERE IN THE CARD.

       WHY IT HAS NONE, read off the rendered DOM rather than the app's
       minified template (measured over 432 rendered cards + a targeted sample):
         * one <img class="spf-product-card__image"> per product image, in
           gallery order
         * `hover-effect`, the class that drives the cross-fade, is on the
           wrapper if and only if there are 2+ layers  (415/415 and 0/17)
         * MAIN is the layer whose `data-variants` holds the variant the card
           links to (the first available variant), else layer 0
         * SECONDARY is layer 1
       So when the card's variant image IS layer 1, main and secondary are the
       same element, it keeps only `image-main`, and the card has no secondary.

       Globo's own rule then does this, with nothing behind it:
         .spf-product-card__image-wrapper.hover-effect:hover
             .spf-product-card__image-main { opacity: 0 !important }
       The one real layer fades to white over four 1x1 GIFs.

       `suppressHover` never fired on these cards because the old early return
       above dropped out before reaching it - and, if it had been reached, it
       was being asked to pin a PAIR that does not exist.

       The principle is the one already shipped for task #25: where there is no
       genuine second photograph, HOVER MUST NOT FIRE. This extends it to the
       case where the second LAYER was never created. Nothing is hidden and
       nothing is created - the one real layer is pinned visible, which is what
       `suppressHover(wrap, main, null)` has always done with a null second
       argument. The arrows still page the product's other photographs, and the
       moment a re-render does give the card a real secondary the release branch
       below un-pins it.

       This is keyed on the STRUCTURE of the card - no secondary element - not
       on a collection, a handle or a shape. */
    if (!secondary) {
      if (G) G.suppressHover(wrapperOf(main), main, null);
      return;
    }
    /* promoteHover() has already put a real second photograph here. Its
       `currentSrc` lags the assignment until the image loads, so reading the
       file back would still say "same as the main photo" and this function
       would pin a card that genuinely has two. Trust the mark. */
    if (secondary.getAttribute('data-tdp-hover-real') === '1') {
      if (G) G.releaseHover(wrapperOf(main), main, secondary);
      return;
    }
    var mainIsGuide = isGuideEl(main);
    var secFile = fileOf(secondary);
    var secIsGuide = secFile ? isGuideEl(secondary) : false;
    /* A hover layer with no resolvable file of its own is just as blank to a
       shopper as a hidden one, and it is how rev 1 failed. Repair it from the
       main photo, and also re-repair anything an earlier pass left on a
       placeholder. */
    var secEmpty = !secFile || stalled(secondary);
    var mainFile = fileOf(main);
    var sameFile = !!secFile && !!mainFile && secFile === mainFile;
    var wrap = wrapperOf(main);
    if ((secIsGuide || secEmpty) && !mainIsGuide) {
      adopt(secondary, main);                 // never blank, never a ruler
      if (G) G.suppressHover(wrap, main, secondary);
    } else if (mainIsGuide && !secIsGuide && secFile) {
      adopt(main, secondary);                 // never open a card on a ruler
    } else if (sameFile && !mainIsGuide) {
      // the app itself rendered one photograph into both layers
      if (G) G.suppressHover(wrap, main, secondary);
    } else if (secFile && !secIsGuide && !sameFile) {
      // a genuine second photograph is present: make sure nothing is pinned
      if (G) G.releaseHover(wrap, main, secondary);
    }
    // Both guides: leave the card exactly as it is. Blanking it would be worse,
    // and the media fix is what resolves those products.
  }

  function run(root) {
    var r = root || document;
    var i, n;
    var globo = r.querySelectorAll('.spf-product-card');
    for (i = 0; i < globo.length; i++) {
      fixCard(globo[i].querySelector('.spf-product-card__image-main'),
              globo[i].querySelector('.spf-product-card__image-secondary'));
    }
    var theme = r.querySelectorAll('product-card, .product-card');
    for (i = 0; i < theme.length; i++) {
      fixCard(theme[i].querySelector('.product-card__image--primary'),
              theme[i].querySelector('.product-card__image--secondary'));
    }
  }

  function arm() { try { run(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
  // Globo renders its grid client-side and re-renders it on every filter, sort
  // and page change, so one pass on load would only ever fix the first screen.
  // The memo lives on the IMAGE, not the card, because a re-render swaps fresh
  // <img> nodes into cards that already carried a card-level flag - that is how
  // the guides came back last time.
  var t = null;
  new MutationObserver(function () {
    if (t) return;
    t = window.setTimeout(function () { t = null; arm(); }, 180);
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('load', arm);

  /* The observer above watches childList only, so an image that RESOLVES after
     our sweep - which is every lazy image on the grid - never triggers another
     pass. Rev 1 had no second pass at all, and that is why two cards stayed
     blank permanently. These late sweeps cost nothing and are what make the
     repair in fixCard reachable. A scroll can also bring newly-lazy images in,
     so listen for that too, debounced. */
  [400, 1200, 2500, 5000, 9000].forEach(function (ms) {
    window.setTimeout(arm, ms);
  });
  var st = null;
  window.addEventListener('scroll', function () {
    if (st) return;
    st = window.setTimeout(function () { st = null; arm(); }, 300);
  }, { passive: true });
})();

/* ==========================================================================
   Tripster Developers 2026-09-15 - TIDY THE BOTTOM LEFT CORNER
   Client: "On the bottom left if you can align both those 2 widgets so it
   looks clean", and "still showing 2" about the accessibility icons.

   WHAT WAS ACTUALLY THERE, measured rather than guessed:
     pandectes-a11y  button#asw-widget   44x44  left 11  bottom 16   bottom left
     ea-accessibility .eac-menuEnableBtn 55x55  right 20 bottom 96   bottom right
     google-youtube   merchant widget                                bottom left
     tidio chat                                                      bottom right

   So he was right that two accessibility widgets were running. An earlier pass
   reported only one, because the Pandectes widget lives inside a SHADOW ROOT and
   a normal querySelectorAll never sees into one. Worth remembering: a widget you
   cannot find is not the same as a widget that is not there.

   The standalone ea-accessibility app is now switched off in settings_data.json.
   The surviving accessibility button is the one bundled with Pandectes GDPR,
   which has to stay on the store anyway for consent.

   That leaves two things bottom left, the Pandectes button and the Google
   widget, and they sat on different left edges at different heights. The Google
   widget takes margins from its own app settings, now 20 and 20. The Pandectes
   button cannot be reached from custom.css at all, because shadow DOM does not
   inherit outside stylesheets, so its rule is injected INTO the shadow root
   here. That is the only route short of an app setting Pandectes does not
   expose.
   ========================================================================== */
(function () {
  // SIDE BY SIDE ON ONE BASELINE, not stacked.
  // Stacking put this button at bottom 90, and at 1280px that landed it
  // directly on top of the hero's "Explore All Products" button. Measured with
  // elementsFromPoint, so it was covering a real call to action, not just
  // sitting near one. Keeping both widgets low and putting the Google widget
  // beside it instead keeps the whole corner out of the page content at every
  // width, and a shared baseline reads as aligned just as well as a stack.
  // LEFT 12, not 20. At 1440px the hero's "Explore All Products" pill starts at
  // x 60, and a 44px button at left 20 ends at 64, so it clipped 4px of that
  // call to action. Measured by intersecting rectangles: a centre-point test
  // said the corner was clean, which is why the first pass missed it. 12 ends
  // the button at 56 and clears the pill at every width checked.
  var LEFT = 12;
  var BOTTOM = 20;   // same baseline as the Google widget
  var MARK = 'tdp-corner-align';

  function place() {
    var host = document.querySelector('pandectes-a11y');
    if (!host || !host.shadowRoot) return false;
    var btn = host.shadowRoot.getElementById('asw-widget');
    if (!btn) return false;

    // A <style> injected into the shadow root did NOT win: the app appends its
    // own !important rule afterwards, and between two !important rules of equal
    // specificity the later one takes it. Measured, the button stayed at
    // left 11 / bottom 16. An inline property set with priority 'important'
    // outranks every stylesheet rule, so set it on the element itself.
    var small = window.matchMedia('(max-width:767px)').matches;
    var l = small ? 12 : LEFT;
    var b = small ? 20 : BOTTOM;
    if (btn.style.getPropertyValue('left') === l + 'px' &&
        btn.style.getPropertyValue('bottom') === b + 'px') return true;
    btn.style.setProperty('left', l + 'px', 'important');
    btn.style.setProperty('bottom', b + 'px', 'important');
    btn.style.setProperty('right', 'auto', 'important');
    btn.setAttribute('data-' + MARK, '1');
    return true;
  }

  // The widget is injected asynchronously and there is no event for it, so poll
  // briefly and then stop. An observer on document.body would not fire for a
  // node appearing inside a shadow root anyway.
  var tries = 0;
  var id = window.setInterval(function () {
    tries++;
    if (place() || tries > 40) window.clearInterval(id);
  }, 250);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
  /* While the cookie consent dialog is up, the accessibility button floats on
     top of it. Measured at 320 to 1024px, where the dialog is bottom anchored
     and full width, the button lands squarely inside it. That is only ever a
     first visit, because the dialog goes once a choice is made, but a first
     visit is exactly when the corner is judged.

     Both widgets belong to Pandectes and both live in their own shadow roots,
     so this reads the consent dialog's own visibility and hides the button for
     as long as it is showing. Nothing is removed, only hidden, and it comes
     straight back. */
  function consentOpen() {
    var cmp = document.querySelector('pandectes-cmp');
    if (!cmp || !cmp.shadowRoot) return false;
    var dlg = cmp.shadowRoot.querySelector('.dialog, [role=dialog]');
    if (!dlg) return false;
    var cs = window.getComputedStyle(dlg);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = dlg.getBoundingClientRect();
    return r.width > 40 && r.height > 40;
  }

  function syncVisibility() {
    var host = document.querySelector('pandectes-a11y');
    if (!host || !host.shadowRoot) return;
    var btn = host.shadowRoot.getElementById('asw-widget');
    if (!btn) return;
    if (consentOpen()) {
      if (btn.getAttribute('data-tdp-hidden') !== '1') {
        btn.setAttribute('data-tdp-hidden', '1');
        btn.style.setProperty('opacity', '0', 'important');
        btn.style.setProperty('pointer-events', 'none', 'important');
      }
    } else if (btn.getAttribute('data-tdp-hidden') === '1') {
      btn.removeAttribute('data-tdp-hidden');
      btn.style.removeProperty('opacity');
      btn.style.removeProperty('pointer-events');
    }
  }

  function tick() { place(); syncVisibility(); }

  // The breakpoint changes the offsets, the app re-renders its button on some
  // interactions, and the consent dialog closes without an event we can see
  // from out here, so re-assert rather than assuming one pass holds.
  window.addEventListener('resize', tick);
  window.setInterval(tick, 700);
})();
